import React from 'react';
import { useFormContext } from 'contexts/FormContext';
import { steps } from 'utils/steps';

/**
 * Renders a button that either advances to the next form step or submits the form.
 *
 * @returns {React.Component} The NextStepButton component.
 */
const NextStepButton = () => {
  const { currentStep, loading } = useFormContext();

  // Button text defaults
  let buttonText = 'Volgende';

  // If there is no next step, display submit button
  if (!steps[currentStep + 1]) {
    buttonText = 'Klus aanbieden';
  }

  return (
    <div className='button-wrapper'>
      <button className='button' type='submit' disabled={loading}>
        {buttonText}
      </button>
    </div>
  );
};

export default NextStepButton;
